module.exports = __webpack_public_path__ + "static/media/server.772aed83.png";